import CTA from './CTA'
import ME from '../../Assets/Images/header.png'
import Socials from './Socials'
// import Typewriter from 'typewriter-effect'



const Header = () => {
  return (
    <header id='home' className='h-screen pt-28 overflow-hidden'>
      <div className='container relative text-center h-full'>
        
      <h5>Hello, Welcome to my page</h5>
      <h1>TOSE, Anthony Sejiro</h1>
      <h5 className='text-light'>Software Developer</h5>
      <CTA/>
      <Socials/>

      <div className='absolute left-1/2 -translate-x-1/2 w-[30rem] h-[40rem] mt-20 pt-20 px-6 pb-6 max-[1024px]:w-80 max-[1024px]:h-[30rem] max-[1024px]:mt-28 max-[600px]:h-[30rem] max-[600px]:mt-4'>
        <img src={ME} alt='me'></img>
      </div>

      <a href='#contact' className='absolute -right-9 bottom-20 rotate-90 text-[0.9rem] font-light max-[600px]:hidden'> scroll down</a>
      </div>
    </header>
  )
}

export default Header
